import { configureDatadog } from '@storebrand-digital/common-datadog';
import packageJson from '../../package.json';
function initDatadog() {
    configureDatadog({
        environment: window.env.DATADOG_ENVIRONMENT,
        clientPublicToken: 'pub60cc221d5b055dbe1d1fde3029c86410',
        appId: '64543387-3176-4811-a439-f3a0bd3db75c',
        appName: 'secure-messages-web',
        appVersion: packageJson.version,
        configureLogging: true,
    });
}
export default initDatadog;
